<template>
  <v-flex xs12 class="px-2 pt-0">
    <div>
      <div class="flex-container-end" bottom v-if="!!complianceIssues.length">
        <span class="red--text">
          <div v-for="(file,i) in masterFiles" :key="i">
            <span
              class="vertical-center-container"
              v-if="!!complianceIssues.filter(item => item.masterFile == file.value).length"
            >
              <v-icon
                class="pr-2"
                :color="$store.state.global.pages[file.value]['color']"
              >{{$store.state.global.pages[file.value]['icon']}}</v-icon>
              {{ `${file.name}` }}
              <span
                v-for="(item,i) in complianceIssues.filter(item => item.masterFile == file.value)"
                :key="i"
                class="ml-1"
              >{{ `${item.type}` }}: {{ makeShortDate(item.date) }}.</span>
            </span>
          </div>
        </span>
      </div>
      <div bottom class="vertical-center-container flex-container-end" v-if="isDuplicate">
        <v-icon color="yellow" class="mr-2">warning</v-icon>
        <span>Duplicate</span>
        <span class="ml-1" v-if="duplicateDriver">Driver</span>
        <span class="ml-1" v-if="duplicateDriver && duplicateVehicle">&</span>
        <span class="ml-1" v-if="duplicateVehicle">Vehicle</span>
      </div>
    </div>
    <div class>
      <div class="flex-container-space-between" style="align-items:center">
        <v-form ref="allocationForm" class="w100" @submit.prevent="submitAllocation()">
          <div class="flex-container-space-between vertical-center-container">
            <transition-group name="field-list" tag="layout-no-padding">
              <v-flex lg2 sm3 xs12 key="7" class="field-list-item">
                <time-picker-wrapper v-model="startTime" label="* Start Time"></time-picker-wrapper>
              </v-flex>

              <v-flex lg3 sm5 xs12 key="6" class="field-list-item">
                <v-autocomplete
                  label="* Tip"
                  color="primary"
                  ref="tipField"
                  :prepend-icon="$store.state.global.pages.tip.icon"
                  clearable
                  :items="filteredTips"
                  @change="spoilId = null"
                  item-text="name"
                  item-value="id"
                  v-model="tipId"
                  :rules="tipRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex lg2 sm4 xs12 key="5" class="field-list-item">
                <v-autocomplete
                  label="* Spoil"
                  color="primary"
                  :prepend-icon="$store.state.global.pages.spoil.icon"
                  clearable
                  :items="filteredSpoils"
                  item-text="name"
                  item-value="id"
                  v-model="spoilId"
                  :rules="spoilRules"
                ></v-autocomplete>
              </v-flex>

              <v-flex lg2 sm4 xs12 key="4" class="field-list-item">
                <v-autocomplete
                  label="* Vehicle"
                  color="indigo"
                  :prepend-icon="$store.state.global.pages.vehicle.icon"
                  clearable
                  :items="filteredVehicles"
                  item-text="vehicleName_vehicleType_contractorName"
                  item-value="id"
                  v-model="vehicleId"
                  :rules="vehicleRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex lg2 sm4 xs12 key="3" class="field-list-item">
                <v-autocomplete
                  label="* Driver"
                  color="indigo"
                  :prepend-icon="$store.state.global.pages.driver.icon"
                  clearable
                  :items="filteredDrivers"
                  item-text="driverName_contractorName"
                  item-value="id"
                  v-model="driverId"
                  :rules="driverRules"
                ></v-autocomplete>
              </v-flex>

              <v-flex lg2 sm4 xs12 key="2" class="field-list-item">
                <v-autocomplete
                  label="Sub-Contractor"
                  color="indigo"
                  :prepend-icon="$store.state.global.pages.contractor.icon"
                  clearable
                  :items="filteredContractors"
                  item-text="name"
                  item-value="id"
                  v-model="contractorId"
                ></v-autocomplete>
              </v-flex>

              <v-flex
                xs12
                class="text-xs-right pb-4 pr-0 field-list-item"
                style="align-self: flex-end"
                key="1"
                v-if="canSubmit"
              >
                <v-btn flat type="submit" :color="$store.state.global.pages.allocation.color">Add</v-btn>
              </v-flex>
            </transition-group>
          </div>
        </v-form>
      </div>
    </div>
  </v-flex>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import TipSpoilService from '@/services/requests/tipSpoilService'
import TimePickerWrapper from '@/components/ui/timePickerWrapper'
import FilterTipSpoils from '@/services/mixins/filterTipSpoils'
import FilterDriverVehicles from '@/services/mixins/filterDriverVehicles'

import getVehicles from '@/services/mixins/getMasterFiles/getVehicles'
import getDrivers from '@/services/mixins/getMasterFiles/getDrivers'
import getContractors from '@/services/mixins/getMasterFiles/getContractors'
import getTips from '@/services/mixins/getMasterFiles/getTips'
import getSpoils from '@/services/mixins/getMasterFiles/getSpoils'
import PrelimAllocationValidation from './validation/prelimAllocationValidation'
import FormatDates from '@/services/mixins/formatDates'
import obj from './mixins/obj'
export default {
  components: {
    TimePickerWrapper,
  },
  mixins: [
    FormatDates,
    FilterTipSpoils,
    getDrivers,
    getVehicles,
    getContractors,
    getTips,
    getSpoils,
    obj,
    PrelimAllocationValidation,
    FilterDriverVehicles,
  ],
  data() {
    return {
      prefix: 'prelimAllocation',
      tipId: null,
      spoilId: null,
      startTime: '',
      driverId: null,
      vehicleId: null,
      contractorId: null,
      // masterFiles: [
      //   { name: 'Sub-contractor', value: 'contractor' },
      //   { name: 'Vehicle', value: 'vehicle' },
      //   { name: 'Driver', value: 'driver' },
      // ],
    }
  },
  methods: {
    action(event) {
      this.commitBatch = true
    },
    submitAllocation() {
      if (!this.$refs.allocationForm.validate() || !this.startTime) {
        this.snack({ text: 'Please correct form errors.', color: 'red' })
        return
      }
      if (this.driverObj.contractorId != this.vehicleObj.contractorId) {
        this.snack({
          text: 'Vehicle and Driver are not from same Sub-Contractor',
          color: 'red',
        })
        return
      }

      this.addAllocation()
    },
    addAllocation() {
      const duplicateLines = []
      if (this.duplicateDriver)
        duplicateLines.push({
          batchId: this.duplicateDriver.allocationBatchHeaderId,
          lineId: this.duplicateDriver.id,
          type: 'Driver',
        })
      if (this.duplicateVehicle)
        duplicateLines.push({
          batchId: this.duplicateVehicle.allocationBatchHeaderId,
          lineId: this.duplicateVehicle.id,
          type: 'Vehicle',
        })
      const allocation = {
        tipId: this.tipId,
        spoilId: this.spoilId,
        driverId: this.driverId,
        vehicleId: this.vehicleId,
        driver: this.driverObj,
        vehicle: this.vehicleObj,
        tip: this.tipObj,
        spoil: this.spoilObj,
        startTime: this.startTime,
        timeEntered: new Date(),
        contractor: this.contractorObj,
        notes: '',
        duplicate: this.isDuplicate,
        duplicateLines: JSON.stringify(duplicateLines),
      }

      this.$store.commit('batchAllocations/addToArrayStatePush', {
        prop: 'allocations',
        value: allocation,
      })
      this.resetAllocation()
    },
    resetAllocation() {
      this.contractorId = null
      this.driverId = null
      this.vehicleId = null
      this.$refs.allocationForm.resetValidation()
      this.$refs.tipField.focus()
    },
    filterListByTipSpoils(array, arrayIdProp, otherIdProp, otherSelectedValue) {
      return array.filter((item) => {
        return !!this.tipSpoils.filter((combination) => {
          return (
            combination[arrayIdProp] == item.id &&
            combination[otherIdProp] == otherSelectedValue
          )
        }).length
      })
    },
    filterByContractor(listName, contractorId) {
      return this[listName].filter((record) => {
        return record.contractor.id == contractorId
      })
    },
  },
  computed: {
    canSubmit() {
      if (
        !!this.tipId &&
        !!this.spoilId &&
        !!this.startTime &&
        !!this.driverId &&
        !!this.vehicleId &&
        this.complianceIssues.length < 1
      ) {
        return true
      } else {
        return false
      }
    },
    siteId: Store.getSet({ store: 'batchAllocations', prop: 'siteId' }),
    date: Store.getSet({ store: 'batchAllocations', prop: 'date' }),
    site: Store.getSet({ store: 'batchAllocations', prop: 'site' }),
    projectId: Store.getSet({ store: 'batchAllocations', prop: 'projectId' }),
    batchLinesByDate: Store.getSet({
      store: 'batchAllocations',
      prop: 'batchLinesByDate',
    }),
    complianceIssues() {
      var expiryDates = []
      var expired = []
      if (!!this.contractorObj) {
        expiryDates.push({
          masterFile: 'contractor',
          date: this.contractorObj.compensationInsuranceExpiry,
          type: 'Compensation Insurance',
        })
        expiryDates.push({
          masterFile: 'contractor',
          date: this.contractorObj.liabilityInsuranceExpiry,
          type: 'Liability Insurance',
        })
        expiryDates.push({
          masterFile: 'contractor',
          date: this.contractorObj.plantAndEquipInsuranceExpiry,
          type: 'Plant/Equipment Insurance',
        })
      }
      if (!!this.driverObj) {
        expiryDates.push({
          masterFile: 'driver',
          date: this.driverObj.licenceExpiry,
          type: 'Licence',
        })
        expiryDates.push({
          masterFile: 'driver',
          date: this.driverObj.vocExpiry,
          type: 'VOC',
        })
        expiryDates.push({
          masterFile: 'driver',
          date: this.driverObj.soaExpiry,
          type: 'Statement of Attainment',
        })
      }
      if (!!this.vehicleObj) {
        expiryDates.push({
          masterFile: 'vehicle',
          date: this.vehicleObj.registrationExpiry,
          type: 'Registration',
        })
        expiryDates.push({
          masterFile: 'vehicle',
          date: this.vehicleObj.pinkSlipExpiry,
          type: 'Pink Slip',
        })
      }
      if (!expiryDates.length) return expired

      for (var expiryDate of expiryDates) {
        if (!!expiryDate.date) {
          var expiryDateObj = new Date(expiryDate.date)
          var today = new Date()
          var daysToExpired = Math.ceil(
            (expiryDateObj - today) / 1000 / 60 / 60 / 24
          )
          if (daysToExpired < 1) expired.push(expiryDate)
        }
      }
      return expired
    },
    duplicateDriver() {
      const duplicate = this.batchLinesByDate.find(
        (line) => this.driverId === line.driverId && !line.duplicate
      )
      return duplicate
    },
    duplicateVehicle() {
      const duplicate = this.batchLinesByDate.find(
        (line) => this.vehicleId === line.vehicleId && !line.duplicate
      )
      return duplicate
    },
    isDuplicate() {
      return !!this.duplicateDriver || !!this.duplicateVehicle
    },
  },
  watch: {
    //WATCH DRIVER AND VEHICLE SELECTED VALUES TO CHANGE SELECTED CONTRACTOR TO ASSOCIATED ID, triggering data synchronization
    driverId(val) {
      if (!!val) {
        this.contractorId = this.driverObj.contractor.id
      }
    },
    vehicleId(val) {
      if (!!val) {
        this.contractorId = this.vehicleObj.contractor.id
      }
    },
  },
}
</script>

<style scoped>
</style>
